/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CardBody = ({ children, lineClamp }) => {

  const classes = classNames('sui-grow', {
    'sui-line-clamp-4': lineClamp,
  });

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

CardBody.displayName = 'CardBody';

CardBody.propTypes = {
  /**
   * If true, will truncate the text at 4 lines
   */
  lineClamp: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node
};

CardBody.defaultProps = {
};

export { CardBody };